import React, { createContext, useContext, useEffect, useReducer } from "react";
const defaultState = {
    'font-size': 0,
    illustrations: true,
    contrast: false,
    grayscale: false,
    underline: false,
};
const CONFIG_NAME = 'ltg-a11y-config';
let localState;
if (typeof window !== 'undefined') {
    localState = window === null || window === void 0 ? void 0 : window.localStorage.getItem(CONFIG_NAME);
}
const initialState = localState ? JSON.parse(localState) : defaultState;
const Context = createContext([initialState, () => { }]);
const MAX_FONT_SIZE_STEPS = 4;
function reducer(state, action) {
    switch (action.type) {
        case "increaseFontSize":
            if (state['font-size'] >= MAX_FONT_SIZE_STEPS)
                return Object.assign(Object.assign({}, state), { 'font-size': MAX_FONT_SIZE_STEPS });
            return Object.assign(Object.assign({}, state), { 'font-size': state['font-size'] + 1 });
        case "decreaseFontSize":
            if (state['font-size'] <= 0)
                return Object.assign(Object.assign({}, state), { 'font-size': 0 });
            return Object.assign(Object.assign({}, state), { 'font-size': state['font-size'] - 1 });
        case "toggleIllustrations":
            return Object.assign(Object.assign({}, state), { illustrations: !state.illustrations });
        case "toggleContrast":
            return Object.assign(Object.assign({}, state), { grayscale: false, contrast: !state.contrast });
        case "toggleGrayscale":
            return Object.assign(Object.assign({}, state), { contrast: false, grayscale: !state.grayscale });
        case "toggleUnderline":
            return Object.assign(Object.assign({}, state), { underline: !state.underline });
        case "reset":
            return Object.assign({}, defaultState);
        default:
            throw new Error("Invalid action type");
    }
}
export function A11yProvider({ children }) {
    const [a11y, dispatch] = useReducer(reducer, initialState);
    useEffect(() => {
        removeClassesStartingWith('ltg-a11y');
        if (JSON.stringify(a11y || {}) === JSON.stringify(defaultState)) {
            localStorage.removeItem(CONFIG_NAME);
            return;
        }
        Object.keys(a11y).map((key) => {
            const value = a11y[key];
            if (value !== defaultState[key]) {
                document.documentElement.classList.add(`ltg-a11y-${key}-${value.toString()}`);
            }
        });
        localStorage.setItem(CONFIG_NAME, JSON.stringify(a11y));
    }, [a11y]);
    return (React.createElement(Context.Provider, { value: [a11y, dispatch] }, children));
}
export function useA11yContext() {
    return useContext(Context);
}
function removeClassesStartingWith(startsWith) {
    const htmlTag = document.documentElement;
    const classNames = htmlTag.className.split(" ");
    const filteredClassNames = classNames.filter((name) => !name.startsWith(startsWith));
    htmlTag.className = filteredClassNames.join(" ");
}
